import styled from 'styled-components';

const SingleLineLayout = styled.div`
  display: flex;
`;

export default SingleLineLayout;